import { FileLink } from '../file-link.model';
import { FocusRange } from '../focus-range.model';
import { NotificationEventType } from '../types/notification-event-type';

import { Icon, WattsonNotification } from './wattson-notification.model';

export class FileNotification extends WattsonNotification {
  /**
   * The target of the notification is a FileLink.
   */
  declare target: FileLink;

  constructor(attributes: Partial<FileNotification> = {}) {
    super();
    Object.assign(this, attributes);
  }

  getIcons(): Icon[] {
    return [{ icon: 'md-check-circle', tooltip: 'notification_panel.file.ready' }];
  }

  getTypeIcon(): string {
    switch (this.eventType) {
      case NotificationEventType.fileReady:
        return 'assignment';
      default:
        return 'face';
    }
  }

  getNotificationAuthor(): string {
    return undefined;
  }

  getFocus(): FocusRange[] {
    return [];
  }

  isRemoteLink(): boolean {
    return true;
  }

  getAlertMessage(): string {
    return `notification_alert.${this.category}.${this.eventType}`;
  }

  getLink(): string {
    return `/volume${this.target.path}`;
  }
}
